import {
    Button,
    Dropdown,
    Form,
    FormGroup,
    InputPlaceholder,
    Segment,
    SegmentContent,
    SegmentHeader,
} from '@/platform/ui';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Deferred, useForm, usePage } from '@inertiajs/react';
import { useEffect } from 'react';

const QuestionnaireForm = ({ submitUrl }) => {
    const { filters, questionnaire, questions, options } = usePage().props;
    const { data, setData, patch, processing, transform } = useForm([]);

    useEffect(() => {
        setData(questionnaire ?? []);
    }, [questionnaire, filters?.type]);

    const handleAdd = () => {
        setData([
            ...data,
            {
                id: `new-${Date.now()}`,
                unique_question_id: '',
                options: [],
            },
        ]);
    };

    const handleChange = (questionnaireId, field, value) => {
        setData([
            ...(data?.map(datum => {
                if (datum.id == questionnaireId) {
                    return {
                        ...datum,
                        [field]: value,
                    };
                }

                return datum;
            }) || []),
        ]);
    };

    const handleRemove = id => {
        setData([...(data?.filter(datum => datum.id !== id) || [])]);
    };

    const handleSubmit = () => {
        transform(formData => ({ data: formData, type: filters?.type }));

        patch(submitUrl);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <div className='mb-4 flex items-center justify-end'>
                <Button type='button' onClick={handleAdd}>
                    <PlusIcon className='size-5' />
                    Vraag toevoegen
                </Button>
            </div>

            {data?.map(questionnaireQuestion => (
                <Segment key={questionnaireQuestion.id}>
                    <SegmentHeader>
                        <Button
                            variant='danger'
                            type='button'
                            onClick={() =>
                                handleRemove(questionnaireQuestion.id)
                            }
                        >
                            <TrashIcon className='size-3.5' />
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <FormGroup>
                            <Deferred
                                data='questions'
                                fallback={<InputPlaceholder label='Vraag' />}
                            >
                                <Dropdown
                                    label='Vraag'
                                    placeholder='Selecteer een vraag'
                                    required
                                    options={questions
                                        ?.filter(
                                            q =>
                                                q.id ==
                                                    questionnaireQuestion.unique_question_id ||
                                                !data?.some(
                                                    datum =>
                                                        datum.unique_question_id ==
                                                        q.id
                                                )
                                        )
                                        .map(q => ({
                                            id: q.id,
                                            name: q?.question?.nl,
                                        }))}
                                    value={
                                        questionnaireQuestion.unique_question_id ||
                                        ''
                                    }
                                    onChange={value =>
                                        handleChange(
                                            questionnaireQuestion.id,
                                            'unique_question_id',
                                            value
                                        )
                                    }
                                />
                            </Deferred>

                            <Deferred
                                data='options'
                                fallback={<InputPlaceholder label='Opties' />}
                            >
                                <Dropdown
                                    label='Opties'
                                    multiple
                                    options={options?.map(o => ({
                                        id: o.id,
                                        name: o?.label?.nl,
                                    }))}
                                    value={questionnaireQuestion.options || []}
                                    onChange={value =>
                                        handleChange(
                                            questionnaireQuestion.id,
                                            'options',
                                            value
                                        )
                                    }
                                />
                            </Deferred>
                        </FormGroup>
                    </SegmentContent>
                </Segment>
            ))}

            <Segment floating>
                <SegmentContent right>
                    <Button
                        type='submit'
                        variant='primary'
                        loading={processing}
                    >
                        Opslaan
                    </Button>
                </SegmentContent>
            </Segment>
        </Form>
    );
};

export default QuestionnaireForm;
